import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import "./View.css";

import * as React from 'react';
import { Document, Page, pdfjs, Thumbnail } from "react-pdf";
import Swal from 'sweetalert2';
import { FaDownload, FaCertificate, FaCheck } from "react-icons/fa";
import * as QueryString from "query-string";
import { verifyPDF } from './verify-pdf';
import { FiRotateCw } from 'react-icons/fi';
import { DocumentCallback } from 'react-pdf/dist/cjs/shared/types';
import { Spinner } from 'reactstrap';
//const { verifyPDF } = require('./verify-pdf');

const PDFThumnail = React.lazy(() => import('./PDFThumnail'));

const options = {
    cMapUrl: '/cmaps/',
    cMapPacked: true,
    standardFontDataUrl: '/standard_fonts/',
};

//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// from another branch
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// from doc
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// from doc but legacy
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

class PDFView extends React.Component<any, {
    filePath: string,
    params: string,
    readOnly: boolean,
    numPages: number,
    pageNumber: number,
    scaleIndex: number,
    scaleList: number[],
    defaultPageRotates: number[],
    base64PDF: string | ArrayBuffer | null,
    isSigned: boolean,
    showSigned: boolean,
    signedBy: string,
    signedEmail: string,
    signedOn: string,
    rotation: number,
    count: number;
    pdfDocumentProxy?: DocumentCallback;
    fetching?: boolean;
    useNativeViewer: boolean;
    blobUrl: string | null;
    detecting: boolean;
}> {
    constructor(props: any) {
        super(props);

        this.state = {
            filePath: '',
            params: '',
            readOnly: false,
            numPages: 0,
            pageNumber: 1,
            scaleIndex: 7,
            scaleList: [0.25, 0.33, 0.5, 0.67, 0.75, 0.80, 0.90, 1, 1.11, 1.25, 1.50, 1.75, 2.0, 2.5, 3, 4, 5],
            defaultPageRotates: [],
            base64PDF: null,
            isSigned: false,
            showSigned: true,
            signedBy: '',
            signedEmail: '',
            signedOn: '',
            rotation: 0,
            count: 0,
            pdfDocumentProxy: undefined,
            fetching: false,
            useNativeViewer: false,
            blobUrl: null,
            detecting: false
        }

        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
        this.onClickGoToPreviousPage = this.onClickGoToPreviousPage.bind(this);
        this.onClickGoToNextPage = this.onClickGoToNextPage.bind(this);
        this.onClickScaleDown = this.onClickScaleDown.bind(this);
        this.onClickScaleUp = this.onClickScaleUp.bind(this);
        this.onClickDownload = this.onClickDownload.bind(this);
        this.onClickSignedBadge = this.onClickSignedBadge.bind(this);
        this.onLoadError = this.onLoadError.bind(this);
        this.onDocumentLoadError = this.onDocumentLoadError.bind(this);
    }

    componentDidMount() {
        var { filePath } = this.props
        let params = QueryString.parse(filePath.substr(filePath.lastIndexOf('?') + 1))
        var readOnly = false
        if (params.read_only) {
            if (String(params.read_only).toLowerCase() == 'true') {
                readOnly = true
            }
        }

        this.setState({ fetching: true });
        fetch(filePath, {
            method: "GET",
            signal: AbortSignal.timeout(120000) // 2 minute
        })
            .then(response => {
                if (response.ok) {
                    return response.blob()
                }
                throw new Error('Something went wrong');
            })
            .then(response => {
                var reader = new FileReader();
                reader.readAsArrayBuffer(response);
                reader.onloadend = () => {
                    var result = reader.result;
                    const verified = verifyPDF.verifyPDF(result);
                    var isSigned = false
                    var signedBy = ''
                    var signedEmail = ''
                    var signedOn = ''
                    if (!verified.message) {
                        var certs = verified.meta?.certs
                        for (let i = 0; i < certs.length; i++) {
                            if (certs[i].clientCertificate) {
                                var issuedTo = certs[i].issuedTo["commonName"]
                                var fixedstring = decodeURIComponent(escape(issuedTo));
                                isSigned = true
                                signedBy = fixedstring
                                signedEmail = ''
                                signedOn = verified.lastModify
                                break;
                            }
                        }
                    }
                    // Force application/pdf MIME type so browser renders inline, not downloads
                    const pdfBlob = new Blob([result as ArrayBuffer], { type: 'application/pdf' });
                    const blobUrl = URL.createObjectURL(pdfBlob);
                    this.setState({
                        filePath: filePath,
                        base64PDF: result,
                        readOnly: (readOnly != undefined) ? readOnly : false,
                        isSigned: isSigned,
                        signedBy: signedBy,
                        signedEmail: signedEmail,
                        signedOn: signedOn,
                        fetching: false,
                        blobUrl,
                        detecting: true
                    })
                }
            })
            .catch((error) => {
                if (error instanceof Error && error.name === 'TimeoutError') {
                    this.setState({ fetching: false })
                    this.onLoadError('ไฟล์มีขนาดใหญ่ กรุณา Download เพื่อเปิดไฟล์');
                } else {
                    this.setState({ fetching: false })
                    this.onLoadError('ไม่พบข้อมูล หรือไม่ได้รับสิทธิ์ให้เข้าดูไฟล์ กรุณาติดต่อผู้ดูแลระบบ');
                }
            })
    }

    componentWillUnmount() {
        if (this.state.blobUrl) {
            URL.revokeObjectURL(this.state.blobUrl);
        }
    }

    componentDidUpdate() {
        let { numPages, pageNumber, scaleIndex, scaleList } = this.state
        if (pageNumber == 1) {
            var btnPreviousPage = document.getElementById('btnPreviousPage') as HTMLButtonElement;
            if ((btnPreviousPage != undefined) && (btnPreviousPage.disabled == false)) {
                btnPreviousPage.disabled = true;
            }
        } else {
            var btnPreviousPage = document.getElementById('btnPreviousPage') as HTMLButtonElement;
            if ((btnPreviousPage != undefined) && (btnPreviousPage.disabled == true)) {
                btnPreviousPage.disabled = false;
            }
        }

        if (pageNumber == numPages) {
            var btnNextPage = document.getElementById('btnNextPage') as HTMLButtonElement;
            if ((btnNextPage != undefined) && (btnNextPage.disabled == false)) {
                btnNextPage.disabled = true;
            }
        } else {
            var btnNextPage = document.getElementById('btnNextPage') as HTMLButtonElement;
            if ((btnNextPage != undefined) && (btnNextPage.disabled == true)) {
                btnNextPage.disabled = false;
            }
        }

        if (scaleIndex == 0) {
            var btnScaleDown = document.getElementById('btnScaleDown') as HTMLButtonElement;
            if ((btnScaleDown != undefined) && (btnScaleDown.disabled == false)) {
                btnScaleDown.disabled = true;
            }
        } else {
            var btnScaleDown = document.getElementById('btnScaleDown') as HTMLButtonElement;
            if ((btnScaleDown != undefined) && (btnScaleDown.disabled == true)) {
                btnScaleDown.disabled = false;
            }
        }

        if (scaleIndex == (scaleList.length - 1)) {
            var btnScaleUp = document.getElementById('btnScaleUp') as HTMLButtonElement;
            if ((btnScaleUp != undefined) && (btnScaleUp.disabled == false)) {
                btnScaleUp.disabled = true;
            }
        } else {
            var btnScaleUp = document.getElementById('btnScaleUp') as HTMLButtonElement;
            if ((btnScaleUp != undefined) && (btnScaleUp.disabled == true)) {
                btnScaleUp.disabled = false;
            }
        }

        // setTimeout(this.adjustScrollSpace, 0);
    }

    adjustScrollSpace = () => {
        const pdf = document.querySelector<HTMLCanvasElement>('.selected-document .react-pdf__Page__canvas');
        if (!pdf) {
            return;
        }

        const clientRect = pdf.getBoundingClientRect();
        if (clientRect.y < 0) {
            pdf.style.transform = `translateY(${-1 * clientRect.y}px)`;
        }
    }

    async onDocumentLoadSuccess(pdf: DocumentCallback) {
        const defaultPageRotates: number[] = []
        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
            const page = await pdf.getPage(pageNum);
            defaultPageRotates.push(page.rotate);
        }

        if (!this.state.detecting) {
            // Already past detection — just refresh proxy and page metadata
            this.setState({ pdfDocumentProxy: pdf, numPages: pdf.numPages, defaultPageRotates });
            return;
        }

        // Detect broken font encoding — fall back to browser native viewer if found.
        // PDF.js signals decoding failure in two ways:
        //   1. Items with str === '' (no ToUnicode mapping for the glyph)
        //   2. Items with garbage ASCII punctuation substituted for the real char
        let useNativeViewer = false;
        try {
            const page = await pdf.getPage(1);
            const textContent = await page.getTextContent();
            const items = (textContent.items as any[]).filter(item => 'str' in item);
            const totalItems = items.length;

            if (totalItems > 10) {
                const emptyItems = items.filter(item => item.str === '').length;
                const text = items.map(item => item.str as string).join('');
                const trimLen = text.trim().length;
                const punctCount = (text.match(/[!-/:-@\[-`{-~]/g) || []).length;
                console.log('[PDFView] font check — totalItems:', totalItems, 'emptyItems:', emptyItems, 'emptyRatio:', (emptyItems / totalItems).toFixed(2), 'trimLen:', trimLen, 'punctRatio:', trimLen > 0 ? (punctCount / trimLen).toFixed(2) : 'n/a');

                if (emptyItems / totalItems > 0.15) {
                    useNativeViewer = true;
                } else if (trimLen > 10 && punctCount / trimLen > 0.2) {
                    useNativeViewer = true;
                }
            } else {
                console.log('[PDFView] font check — totalItems too few:', totalItems);
            }
            console.log('[PDFView] useNativeViewer:', useNativeViewer);
        } catch {
            // ignore detection errors — keep react-pdf
        }

        this.setState({
            pdfDocumentProxy: pdf,
            numPages: pdf.numPages,
            defaultPageRotates,
            useNativeViewer,
            detecting: false
        });
    }

    onDocumentLoadError() {
        this.onLoadError('ไม่พบข้อมูล หรือไม่ได้รับสิทธิ์ให้เข้าดูไฟล์ กรุณาติดต่อผู้ดูแลระบบ')
    }

    onLoadError(errorMessage: string) {
        Swal.fire({
            title: 'ไม่สำเร็จ!',
            // text: 'ไม่พบข้อมูล หรือไม่ได้รับสิทธิ์ให้เข้าดูไฟล์ กรุณาติดต่อผู้ดูแลระบบ',
            text: errorMessage,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ยืนยัน!'
        }).then((result) => {
            if (result.value) {
            }

            this.setState({
                filePath: '',
                base64PDF: '',
                readOnly: true
            })
        })
    }

    changePage = (pageNumber: number) => {
        this.setState({ pageNumber });
    };

    onClickPageThumnail(pageNumber: number) {
        this.changePage(pageNumber);
    }

    onClickGoToPreviousPage() {
        const { pageNumber } = this.state;
        if (pageNumber > 1) {
            this.changePage(pageNumber - 1);
        }
    }

    onClickGoToNextPage() {
        const { numPages, pageNumber } = this.state;
        if (pageNumber < numPages) {
            this.changePage(pageNumber + 1);
        }
    }

    onClickScaleUp() {
        let { scaleIndex, scaleList } = this.state
        if (scaleIndex < scaleList.length - 1) {
            this.setState({
                scaleIndex: scaleIndex + 1
            })
        }
    }

    onClickScaleDown() {
        let { scaleIndex } = this.state
        if (scaleIndex > 0) {
            this.setState({
                scaleIndex: scaleIndex - 1
            })
        }
    }

    downloadFile(filePath) {
        fetch(filePath, {
            method: 'GET',
        }).then(function (resp) {
            return resp.blob();
        }).then(function (blob) {
            const newBlob = new Blob([blob], { /*type: "application/pdf", charset: "UTF-8"*/ })

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);

                return;
            }
            const data = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            //link.dataType = "json";
            link.href = data;
            link.download = filePath.substr(filePath.lastIndexOf('file_name=') + 10);
            link.dispatchEvent(new MouseEvent('click'));
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data)
            }, 60);
        });
    }

    onClickDownload() {
        let { filePath, params } = this.state
        //params += '&download=true'
        //var url = window.location.origin + '/view?' + params
        //window.open(filePath)
        this.downloadFile(filePath)
    }

    viewScale = () => {
        var scale = this.state.scaleList[this.state.scaleIndex] * 100;

        return scale.toFixed(0)
    }

    onClickSignedBadge() {
        this.setState({
            showSigned: !this.state.showSigned
        })
    }

    onClickRotate = () => {
        this.setState({ rotation: (this.state.rotation + 90) % 360 });
    };

    // scrollToTop = () => window.scrollTo({ top: 0 });

    render() {
        const { filePath, readOnly, isSigned, signedBy, signedOn, showSigned, fetching, useNativeViewer, blobUrl, detecting } = this.state

        // Show loader when fetching
        if (!filePath && fetching) {
            return (
                <div
                    style={{
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'white',
                        position: 'fixed',
                        zIndex: 9_999,
                        left: 0,
                        top: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Spinner color="primary" />
                </div>
            );
        }

        if (!filePath || !blobUrl) {
            return null;
        }

        // While detecting: show spinner + run hidden Document for onDocumentLoadSuccess to fire
        if (detecting) {
            return (
                <div
                    style={{
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'white',
                        position: 'fixed',
                        zIndex: 9_999,
                        left: 0,
                        top: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <div style={{ position: 'absolute', height: 0, overflow: 'hidden', pointerEvents: 'none' }}>
                        <Document
                            file={blobUrl}
                            onLoadSuccess={this.onDocumentLoadSuccess}
                            onLoadError={this.onDocumentLoadError}
                            options={options}
                        />
                    </div>
                    <Spinner color="primary" />
                </div>
            );
        }

        if (useNativeViewer && blobUrl) {
            return (
                <div
                    className="Showcase Showcase--react-pdf"
                    onContextMenu={(e) => e.preventDefault()}
                >
                    <div className="react-component" style={{ flex: 1, position: 'relative' }}>
                        <iframe
                            src={blobUrl}
                            style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
                            title="PDF Viewer"
                        />
                        {isSigned &&
                            <div className="show-signed">
                                <button id="btnSigned" type="button" style={{ position: 'relative', opacity: 1, background: 'none', border: 'none', height: '60px', width: '30px' }} onClick={this.onClickSignedBadge}>
                                    <span style={{ position: 'absolute', top: '5px', left: '3px' }}>
                                        <FaCertificate style={{ fontSize: '24px', color: 'white', margin: 0 }} />
                                    </span>
                                    <span style={{ position: 'relative', top: '-10px', left: '0' }}>
                                        <FaCheck style={{ fontSize: '14px', color: 'rgb(80, 200, 120)', margin: 0 }} />
                                    </span>
                                </button>
                                {showSigned &&
                                    <div className="signed-data">
                                        <span className="truncate_text" data-id="name">
                                            <p style={{ fontSize: '14px', color: 'white', margin: 0 }}>
                                                Signed By: {signedBy}
                                            </p>
                                        </span>
                                        <span className="truncate_text" data-id="date">
                                            <p style={{ fontSize: '11px', color: 'white', margin: 0 }}>
                                                Signed On: {signedOn}
                                            </p>
                                        </span>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            );
        }

        return (
            <div
                className="Showcase Showcase--react-pdf"
                onContextMenu={(e) => e.preventDefault()}
            >
                <div className="pdf-paging">
                    {/* {
                        Array
                            .from({ length: this.state.numPages })
                            .map((_, index) => (
                                // Don't change it. It's a lazy loading.
                                <React.Suspense
                                    key={index}
                                    fallback={<p>Cannot load pdf</p>}
                                >
                                    <PDFThumnail
                                        file={blobUrl}
                                        onLoadError={this.onDocumentLoadError}
                                        onLoadSuccess={this.onDocumentLoadSuccess}
                                        options={options}
                                        pageNumber={(index + 1)}
                                        currentPageNumber={this.state.pageNumber}
                                        scale={this.state.scaleList[0]}
                                        onClick={(_) => this.onClickPageThumnail(index + 1)}
                                    />
                                </React.Suspense>
                            ))
                    } */}
                    {
                        this.state.pdfDocumentProxy
                        && Array
                            .from({ length: this.state.numPages })
                            .map((_, index) => (
                                <Thumbnail
                                    key={index}
                                    pdf={this.state.pdfDocumentProxy}
                                    pageNumber={index + 1}
                                    scale={0.25}
                                    // rotate={((this.state.defaultPageRotates[index] ?? 0) + this.state.rotation) % 360}
                                    onItemClick={({ pageNumber }) => this.onClickPageThumnail(pageNumber)}
                                    className={index + 1 === this.state.pageNumber ? "pdf-active" : ''}
                                />
                            ))

                    }
                </div>
                <div
                    className="react-component"
                    onContextMenu={(e) => e.preventDefault()}
                >
                    <Document
                        className="selected-document"
                        file={blobUrl}
                        onLoadError={this.onDocumentLoadError}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        // className="pdf-container"
                        options={options}
                    >
                        <Page
                            pageNumber={this.state.pageNumber}
                            scale={this.state.scaleList[this.state.scaleIndex]}
                            rotate={((this.state.defaultPageRotates[this.state.pageNumber - 1] ?? 0) + this.state.rotation) % 360}
                            renderTextLayer={false}
                        />
                        <div style={{ zIndex: 1_000 }} className="page-controls">
                            <button id="btnPreviousPage" type="button" onClick={this.onClickGoToPreviousPage}>‹</button>
                            <span>{this.state.pageNumber} of {this.state.numPages}</span>
                            <button id="btnNextPage" type="button" onClick={this.onClickGoToNextPage}>›</button>
                            <span>&nbsp;|&nbsp;</span>
                            <button id="btnScaleDown" type="button" onClick={this.onClickScaleDown}>-</button>
                            <span>{this.viewScale()}%</span>
                            <button id="btnScaleUp" type="button" onClick={this.onClickScaleUp}>+</button>
                            {readOnly == false &&
                                <div style={{ display: "inline-block" }}>
                                    <span>&nbsp;|&nbsp;</span>
                                    <button id="btnDownload" type="button" onClick={this.onClickDownload}><FaDownload /></button>
                                </div>
                            }
                            <button id="btnRotate" type="button" onClick={this.onClickRotate}><FiRotateCw /></button>
                        </div>
                        {isSigned &&
                            <div className="show-signed">
                                <button id="btnSigned" type="button" style={{ position: 'relative', opacity: 1, background: 'none', border: 'none', height: '60px', width: '30px' }} onClick={this.onClickSignedBadge}>
                                    <span style={{ position: 'absolute', top: '5px', left: '3px' }}>
                                        <FaCertificate style={{ fontSize: '24px', color: 'white', margin: 0 }} />
                                    </span>
                                    <span style={{ position: 'relative', top: '-10px', left: '0' }}>
                                        <FaCheck style={{ fontSize: '14px', color: 'rgb(80, 200, 120)', margin: 0 }} />
                                    </span>
                                </button>
                                {showSigned &&
                                    <div className="signed-data">
                                        <span className="truncate_text" data-id="name">
                                            <p style={{ fontSize: '14px', color: 'white', margin: 0 }}>
                                                Signed By: {signedBy}
                                            </p>
                                        </span>
                                        {/*<span className="truncate_text" data-id="email">*/}
                                        {/*    <p style={{ fontSize: '11px', color: 'rgb(var(--grey_5))', margin: 0 }}>*/}
                                        {/*        {signedEmail}*/}
                                        {/*    </p>*/}
                                        {/*</span>*/}
                                        <span className="truncate_text" data-id="date">
                                            <p style={{ fontSize: '11px', color: 'white', margin: 0 }}>
                                                Signed On: {signedOn}
                                            </p>
                                        </span>
                                    </div>
                                }
                            </div>
                        }
                    </Document>
                </div>
            </div>
        );
    }
}

export default PDFView;
